export const ADS_LABELS: Record<string, string> = {
  partner: 'Партнерский',
  ads: 'Реклама',
  'press-release': 'Пресс-релиз',
  social: 'Социальная реклама',
};
